import { cn } from '@/utils/classname';

type BadgeMode = 'query' | 'agent' | 'auto';

interface ModeBadgeProps {
  mode: BadgeMode;
}

const BADGE_CONFIG: Record<BadgeMode, { label: string; className: string }> = {
  query: {
    label: 'Query',
    className: 'bg-chariot-background-secondary text-chariot-text-secondary',
  },
  agent: {
    label: 'Agent',
    className: 'bg-chariot-brand-primary/10 text-chariot-brand-primary',
  },
  auto: {
    label: 'Auto',
    className: 'bg-chariot-status-warning/10 text-chariot-status-warning',
  },
};

export function ModeBadge({ mode }: ModeBadgeProps) {
  const config = BADGE_CONFIG[mode];
  return (
    <span
      className={cn(
        'inline-flex rounded-full px-1.5 py-0.5 text-[10px] leading-tight font-medium',
        config.className
      )}
    >
      {config.label}
    </span>
  );
}
